module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nuLasb/images/9781439647646.jpg?1685203787763",
      "alt": "This image is the cover for the book Rexburg, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rexburg, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The mountainous terrain and abundance of rivers near what would later become the city of Rexburg were a magnet for the Missouri Fur Company; in 1810, Maj. Andrew Henry, a representative for the company, built a trading post seven miles north of Rexburg. On March 10, 1883, Thomas E. Ricks, who was accompanied by 10 men, settled an area located east of the three buttes across the Snake River. Rexburg�s early days reflected the typical lifestyle of many northwestern towns in the late 19th century: saloons dotted Main Street, cowboys got into shooting matches in town, and farmers struggled to conquer mother earth while pioneer families endured the cold harsh winters. The combination of tall sagebrush and volcanic ash proved to be an ideal agricultural combination for producing wheat, barley, and potatoes. Education was important, and a college was established in the early years, starting in 1888.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lowell J. Parkinson, Mardi J. Parkinson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The majority of the pictures for this book came from the private collection of authors Lowell J. and Mardi J. Parkinson, who are third-generation residents of the area. The commentary was years in the making. As young children, the authors personally interviewed descendants of the original pioneers and recorded their stories.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0